import request from '../utils/request'
// // import { encodeQuery } from '../utils/helperFunctions'
import { FETCH_TYPES } from '../utils/constants'
import { REST_API } from './API_Routes'
import ServiceBase from './ServiceBase'

export default class Notifications extends ServiceBase {
  check_notification = async () => {
    const response = await request(REST_API.NOTIFICATION_CHECK)
    return response
  }

  chat_send = async (SUBMIT_VALUES) => {
    // const option = {
    //   method: FETCH_TYPES.POST,
    //   body,
    // }
    // const response = await request(REST_API.CHAT_SEND, option)
    // return response

    const formData = new FormData()
    Object.keys(SUBMIT_VALUES).forEach((key) => {
      if (SUBMIT_VALUES[key]) {
        if (Array.isArray(SUBMIT_VALUES[key])) {
          SUBMIT_VALUES[key].forEach((item) => {
            formData.append(key + '[]', item)
          })
        } else {
          formData.append(key, SUBMIT_VALUES[key])
        }
      }
    })

    const option = {
      method: FETCH_TYPES.POST,
      body: formData,
    }
    const token = true
    const isFormData = true
    const response = await request(
      REST_API.CHAT_SEND,
      option,
      token,
      isFormData,
    )
    return response
  }

  chat_get_messages = async (id) => {
    const response = await request(REST_API.CHAT_MESSAGES + id)
    return response
  }
}
